import React, { useRef, useState } from 'react';
import styles from "./FileSelection.module.scss";
import { useGlobalContext } from 'seagull';
import { Button, IconButton, Spinner, Typography, TextButton } from 'seagull';
import { Plus, TrashLine } from 'seagull/icons';
export function FilesSection(props) {
  const {
    uploadFile,
    deliverables,
    billCommandStatus,
    openFile,
    deleteFile
  } = props;
  const fileInputRef = useRef(null);
  const globalContext = useGlobalContext();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);

  const triggerInput = () => fileInputRef.current && fileInputRef.current.click();

  const onFileSelected = async event => {
    setIsUploading(true);

    if (!event.target.files || !event.target.files.length) {
      return;
    }

    await readFile(event.target.files[0]);
    setIsUploading(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const readFile = async file => {
    if (!file) {
      return;
    }

    if (!file.name.endsWith('.pdf')) {
      return globalContext.showErrorToast('Invalid file type: must be .pdf');
    }

    if (file.size > 10000000) {
      return globalContext.showErrorToast('File exceeds size limit');
    }

    setUploadFailed(false);

    try {
      const fileText = await file.text();

      if (fileText.substring(fileText.lastIndexOf('<<'), fileText.lastIndexOf('>>')).includes('/Encrypt')) {
        return globalContext.showErrorToast('Can not upload encrypted file. Please upload a non encrypted file and try again', 'no-encrypted-files-toast');
      }

      await uploadFile(file);
    } catch (_unused) {
      setUploadFailed(true);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.fileSection
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fileUpload
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fileUploadButtonWrapper
  }, /*#__PURE__*/React.createElement("input", {
    className: styles.fileInput,
    ref: fileInputRef,
    type: "file",
    accept: ".pdf",
    "data-testid": "manage-delivery-file-input",
    onChange: onFileSelected,
    disabled: billCommandStatus !== 'inProgress'
  }), billCommandStatus === 'inProgress' && /*#__PURE__*/React.createElement(Button, {
    "data-testid": "manage-delivery-upload-button",
    skin: "primaryOutline",
    prefixIcon: !isUploading && /*#__PURE__*/React.createElement(Plus, null),
    onClick: triggerInput,
    className: styles.fileUploadButton,
    disabled: isUploading,
    size: "small"
  }, isUploading ? /*#__PURE__*/React.createElement(Spinner, {
    size: 24,
    "data-testid": "manage-delivery-upload-spinner"
  }) : 'Upload file'), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    as: "span"
  }, "*Upload PDF smaller than 10mb."))), uploadFailed && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    skin: "error",
    as: "span",
    "data-testid": "manage-delivery-file-upload-error"
  }, ' ', "Failed to upload. Please try again.")), deliverables.length > 0 && /*#__PURE__*/React.createElement("ol", {
    className: styles.files
  }, deliverables.map(deliverable => /*#__PURE__*/React.createElement("li", {
    key: deliverable.fileId,
    className: styles.fileRow
  }, /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "manage-delivery-file-name",
    underline: "none",
    onClick: () => openFile(deliverable.fileId),
    size: "small"
  }, deliverable.filename), billCommandStatus === 'inProgress' && /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => deleteFile(deliverable.fileId),
    "data-testid": "manage-delivery-delete-button"
  }, /*#__PURE__*/React.createElement(TrashLine, null))))));
}